"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
const zodContactMethods = zod_1.z
    .array(zod_1.z.enum(['email', 'sms']))
    .min(1)
    .max(2)
    .nonempty()
    .refine((arr) => new Set(arr).size === arr.length, { message: 'Array contains duplicate values' });
const newAlertSchema = zod_1.z.object({
    alertType: zod_1.z.string(),
    alertRules: zod_1.z.array(zod_1.z.object({
        key: zod_1.z.string(),
        operator: zod_1.z.string(),
        value: zod_1.z.string(),
        unit: zod_1.z.string().nullable(),
    })),
    blockIds: zod_1.z.array(zod_1.z.number()).nullable(),
    contacts: zod_1.z
        .array(zod_1.z.object({
        contactId: zod_1.z.string(),
        contactMethods: zodContactMethods,
    }))
        .nullable(),
    endDate: zod_1.z.string().datetime().nullable(),
    frequencyMinutes: zod_1.z.number(),
    groups: zod_1.z
        .array(zod_1.z.object({
        groupId: zod_1.z.number(),
        contactMethods: zodContactMethods,
    }))
        .nullable(),
    insectId: zod_1.z.number().nullable(),
    name: zod_1.z.string().max(150),
    notifyOwnerByEmail: zod_1.z.boolean(),
    notifyOwnerBySMS: zod_1.z.boolean(),
    propertyIds: zod_1.z.array(zod_1.z.number()).nullable(),
    sleepMinutes: zod_1.z.number().nullable(),
    startDate: zod_1.z.string().datetime().nullable(),
    stationGeoms: zod_1.z.array(zod_1.z.string()).nullable(),
});
exports.requestSchema = zod_1.z
    .object({
    legacyV3AlertsToUpdate: zod_1.z.record(zod_1.z.string(), newAlertSchema.omit({ alertType: true })).optional(),
    legacyV3AlertsToDelete: zod_1.z.array(zod_1.z.string()).optional(),
    legacyV3AlertsToCreate: zod_1.z.array(newAlertSchema).optional(),
})
    .refine((args) => !!Object.keys(args).length, {
    message: 'Request object must contain at least one argument',
});
exports.path = '/legacy-v3-alerts-management';
//# sourceMappingURL=index.js.map